import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from '../../widgets/Selectors/WidgetBranchSelector'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import { lzDownloadBlobFile, wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import DataReportTable from './DataReportTable'
import Loading from 'src/helpers/commons/loader'
import ErrorMessage from 'src/widgets/ErrorComponent/ErrorMessage'
import { JobTypeOptions } from 'src/helpers/commons/dropdownOptions'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import {
  getExcelDateExportConfig,
  useMasterDateTimeFormats,
} from 'src/helpers/commons/masterDateFormat'

export default function EmployeeDataReport() {
  const Base = new BaseListing()
  const { dateFormat, formatDate, formatDateTime } = useMasterDateTimeFormats()
  const [isLoading, setIsLoading] = useState(false)
  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [JobType, setJobType] = useState('')
  const [ResignationStatus, setResignationStatus] = useState(0)


  const [errors, setErrors] = useState([])
  const [reportData, setReportData] = useState([])
  const RESIGNATION_STATUS_ACTIVE = 0;
  const RESIGNATION_STATUS_RESIGNED = 1;
  const RESIGNATION_STATUS_TERMINATE = 2;
  const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
  const RESIGNATION_STATUS_RETIREMENT = 4;
  const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;
  
  const RESIGNATION_STATUS_NAME = {
    0: 'Active',
    1: 'Resigned',
    2: 'Terminated',
    3: 'Contract Discontinued',
    4: 'Retired',
    5: 'Passed Away',
  };
  
  const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
    { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
    { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
    { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
    { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
    { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
    { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  ];

  const generatePDF = () => {
    const doc = new jsPDF('landscape')
    const logo = 'assets/wil-icon.png'
    const img = new Image()
    var totalPagesExp = '{total_pages_count_string}'
    let yPosition = 45

    const headRows = [
      {
        content: 'Sr',
      },
      {
        dataKey: 'id',
        content: 'ID',
      },
      {
        dataKey: 'personal_file_no',
        content: 'Personal File No.',
      },
      {
        dataKey: 'full_name',
        content: 'Full Name',
      },
      {
        dataKey: 'branch.name',
        content: 'Branch',
      },
      {
        dataKey: 'department.name',
        content: 'Department',
      },
      {
        dataKey: 'designation.name',
        content: 'Designation',
      },
      {
        dataKey: 'mobile_no',
        content: 'Mobile no.',
      },
      {
        dataKey: 'cnic',
        content: 'CNIC',
      },
      {
        dataKey: 'date_of_birth',
        content: 'Date Of Birth',
      },
      {
        dataKey: 'date_of_joining',
        content: 'Date Of Joining',
      },
      {
        dataKey: 'duration',
        content: 'Duration',
      },
      {
        dataKey: 'age',
        content: 'Age',
      },
      {
        dataKey: 'job_status',
        content: 'Job Status',
      },
    ]

    const employeeDetails = reportData.map((employee, index) => [
      index + 1,
      { content: employee.id, styles: { textColor: '#0000FF' } },
      employee.personal_file_no,
      employee.full_name,
      employee.branch?.name || '',
      employee.department?.name || '',
      employee.designation?.name || '',
      employee.mobile_no,
      employee.cnic,
      { content: formatDate(employee.date_of_birth, '-') },
      { content: formatDate(employee.date_of_joining, '-') },
      employee.duration,
      employee.age,
      {
        content: employee.job_status,
        styles: {
          textColor: employee.job_status === 'Trainee' ? '#0000FF' : '#008000',
        },
      },
    ])

    doc.autoTable({
      head: [headRows],
      body: employeeDetails,
      startY: 45,
      margin: { top: 50, bottom: 20, left: 10, right: 10 },
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 280,
      styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        setFontSize: 8,
        font: 'helvetica',
      },

      didDrawPage: function (data) {
        //get page no
        totalPagesExp = doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
        let pageNo = doc.internal.getNumberOfPages()
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth() // Header

        doc.setTextColor('#3c4b64')
        doc.setFont('Helvetica', 'bold') //Header middle branch logo

        doc.addImage(logo, 'PNG', pageWidth - 280, 4, 25, 25)
        doc.line(pageWidth - 254, 7, pageWidth - 254, 27) // Adjust the coordinates as needed
        doc.setFontSize(11)
        doc.text('WAH', pageWidth - 251, 10, { align: 'left' })
        doc.setFont('Helvetica')
        doc.text('INDUSTRIES', pageWidth - 251, 15)
        doc.text('LIMITED', pageWidth - 251, 20)
        doc.setFontSize(9)
        doc.text('www.wahindustries.com', pageWidth - 251, 25)

        doc.setFontSize(14)
        doc.text('Employee Data Report', pageWidth - 20, 10, { align: 'right' }) // Add header separator

        yPosition -= -5 // Set alignment for the text that follows the line
        doc.setFont('Helvetica')
        doc.setFontSize(12)
        doc.setTextColor('#3c4b64')

        //Page No
        var str = 'Page ' + pageNo
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }

        doc.setTextColor('black')
        doc.text(str, 10, pageHeight - 4)
      },
    })

    doc.setFontSize(10)
    const printReport =
      'This Report is printed through ERP at ' + formatDateTime(moment(), moment().format('YYYY-MM-DD HH:mm:ss'))
    const styleReport = { halign: 'center' }
    const pageWidth = doc.internal.pageSize.width
    const textWidth =
      (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const startXForPrintReport = (pageWidth - textWidth) / 2
    const startYForPrintReport = doc.autoTable.previous.finalY + 20

    doc.text(printReport, startXForPrintReport, startYForPrintReport, styleReport)

    doc.save('EmployeeDetails.pdf')
  }

  // const getDepartments = (branch_id) => {
  //   if (branch_id !== 0) {
  //     wtApiCall(
  //       'dropdown',
  //       {
  //         dropdown_names: 'departments',
  //         branch_id: branch_id,
  //       },
  //       'get',
  //       (result) => {
  //         if (result !== null) {
  //           if (result.data.length > 0) {
  //             setDepartments(result.data[0]['departments']) // as I am calling only department dropdown I have mentioned it explicitly
  //           }
  //         }
  //       },
  //       (result) => {
  //         lzNotifyErrorMessageFromResult(result)
  //       },
  //     )
  //   }
  // }

  const changeValues = (key, val) => {
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    if (key === 'resignation_status') {
      setResignationStatus(val.value)
    }
  }

  const getReportData = () => {
    setIsLoading(true)
    wtApiCall(
      'reports/employee_data_report',
      getReportFilters(),
      'get',
      (response) => {
        const { data } = response
        setReportData(data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }

  const getReportFilters = () => ({
    employee_id: 0,
    parent_branch_id: branchId,
    department_id: department_id,
    designation_id: designation_id,
    job_status: JobType,
    resignation_status: ResignationStatus,
  })

  const getDesignationType = (employee) => {
    if (Number(employee?.designation?.is_officer) === 1) {
      return 'Officer'
    }

    switch (Number(employee?.designation?.type)) {
      case 1:
        return 'Staff'
      case 2:
        return 'Worker'
      case 3:
        return 'Daily Wager'
      default:
        return ''
    }
  }

  const getRowStyle = (index) => (index % 2 === 0 ? 'background-color:#F8FBFF;' : 'background-color:#FFFFFF;')

  const getJobStatusStyle = (jobStatus) => {
    if (jobStatus === 'Permanent') {
      return 'font-weight:700;color:#2E7D32;'
    }

    if (jobStatus === 'Trainee') {
      return 'font-weight:700;color:#1565C0;'
    }

    return 'font-weight:700;color:#AD1457;'
  }

  const escapeExcelValue = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const buildExcelDateCell = (value, style) => {
    const exportConfig = getExcelDateExportConfig(value, dateFormat)

    if (exportConfig.type === 'empty') {
      return `<td style="${style}text-align:center;"></td>`
    }

    if (exportConfig.type === 'str') {
      return `<td style="${style}text-align:center;" x:str>${escapeExcelValue(
        exportConfig.value,
      )}</td>`
    }

    return `<td style="${style}text-align:center;mso-number-format:'${exportConfig.numberFormat}';" x:num>${exportConfig.value}</td>`
  }

  const buildExcelHtml = () => {
    const rows = reportData
      .map((employee, index) => {
        const rowStyle = getRowStyle(index)

        return `
          <tr>
            <td style="${rowStyle}text-align:center;font-weight:700;color:#5B6573;">${escapeExcelValue(index + 1)}</td>
            <td style="${rowStyle}text-align:center;font-weight:700;color:#0B5ED7;">${escapeExcelValue(employee.id)}</td>
            <td style="${rowStyle}font-weight:700;color:#6F42C1;">${escapeExcelValue(employee.personal_file_no)}</td>
            <td style="${rowStyle}font-weight:700;color:#C2185B;">${escapeExcelValue(employee.full_name)}</td>
            <td style="${rowStyle}color:#000000;">${escapeExcelValue(employee.branch?.name)}</td>
            <td style="${rowStyle}color:#000000;">${escapeExcelValue(employee.department?.name)}</td>
            <td style="${rowStyle}color:#000000;font-weight:700;">${escapeExcelValue(employee.designation?.name)}</td>
            <td style="${rowStyle}color:#000000;font-weight:700;">${escapeExcelValue(getDesignationType(employee))}</td>
            <td style="${rowStyle}color:#455A64;">${escapeExcelValue(employee.mobile_no)}</td>
            <td style="${rowStyle}color:#37474F;">${escapeExcelValue(employee.cnic)}</td>
            ${buildExcelDateCell(employee.date_of_birth, `${rowStyle}color:#7B1FA2;`)}
            ${buildExcelDateCell(employee.date_of_joining, `${rowStyle}color:#00838F;font-weight:700;`)}
            <td style="${rowStyle}font-weight:700;color:#D32F2F;">${escapeExcelValue(employee.duration)}</td>
            <td style="${rowStyle}font-weight:700;color:#388E3C;">${escapeExcelValue(employee.age)}</td>
            <td style="${rowStyle}${getJobStatusStyle(employee.job_status)}">${escapeExcelValue(employee.job_status)}</td>
          </tr>`
      })
      .join('')

    return `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Employee Report</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
          <style>
            body{font-family:Calibri,Arial,sans-serif;font-size:11pt;color:#000;}
            table{border-collapse:collapse;width:100%;}
            td,th{border:1px solid #cfd8e3;padding:6px 8px;vertical-align:middle;}
            .title{font-size:18pt;font-weight:700;text-align:center;border:none;padding:10px 0;}
            .meta{font-style:italic;text-align:center;border:none;color:#44546A;padding:4px 0 8px 0;}
            .header{background:#1F4E78;color:#fff;font-weight:700;text-align:center;}
            .w-sr{width:45px;}.w-id{width:60px;}.w-pf{width:110px;}.w-name{width:200px;}
            .w-branch,.w-dept,.w-desig,.w-type{width:130px;}.w-mobile{width:100px;}.w-cnic{width:130px;}
            .w-date{width:95px;}.w-duration,.w-age{width:150px;}.w-status{width:100px;}
          </style>
        </head>
        <body>
          <table>
            <tr><td class="title" colspan="15">Employee Data Report</td></tr>
            <tr><td class="meta" colspan="15">Generated at: ${escapeExcelValue(formatDateTime(moment(), moment().format('YYYY-MM-DD HH:mm:ss')))}</td></tr>
            <tr>
              <th class="header w-sr">S#</th>
              <th class="header w-id">ID</th>
              <th class="header w-pf">Personal File No.</th>
              <th class="header w-name">Full Name</th>
              <th class="header w-branch">Branch</th>
              <th class="header w-dept">Department</th>
              <th class="header w-desig">Designation</th>
              <th class="header w-type">Type</th>
              <th class="header w-mobile">Mobile No.</th>
              <th class="header w-cnic">CNIC</th>
              <th class="header w-date">Date Of Birth</th>
              <th class="header w-date">Date Of Joining</th>
              <th class="header w-duration">Duration</th>
              <th class="header w-age">Age</th>
              <th class="header w-status">Job Status</th>
            </tr>
            ${rows}
          </table>
        </body>
      </html>
    `
  }

  const exportToExcel = async () => {
    setIsLoading(true)
    try {
      const excelBlob = new Blob([buildExcelHtml()], {
        type: 'application/vnd.ms-excel;charset=utf-8;',
      })
      lzDownloadBlobFile(
        excelBlob,
        `EmployeeDataReport_${moment().format('YYYY_MM_DD_HH_mm_ss')}.xls`,
      )
    } finally {
      setIsLoading(false)
    }
  }

  // const getPDFReportData = () => {
  //   wtApiCall(
  //     'employee_data_report',
  //     {},
  //     'get',
  //     (response) => {
  //       const { data } = response
  //       generatePDF(data)
  //     },
  //     (error) => {
  //       lzNotifyErrorMessageFromResult(error)
  //     },
  //   )
  // }


  useEffect(() => {
    Base.dropdownData(
      'branches,designations',
      {},
      [setBranches, setDesignations],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Employee Data Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      border: '1px solid #d8e0ea',
                      borderRadius: '12px',
                      padding: '18px 18px 10px',
                      boxShadow: '0 4px 14px rgba(60, 75, 100, 0.06)',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '18px',
                          fontWeight: '700',
                          color: '#25364d',
                          lineHeight: 1.2,
                          minWidth: '76px',
                        }}
                      >
                        Filters
                      </div>
                      <div style={{ flex: '1 1 0' }}>
                        <CRow className="g-3">
                          <CCol xl={2} lg={4} md={6}>
                            <CInputGroup>
                              <label>Department</label>
                              <WidgetDepartmentSelector
                                departments={departments}
                                displayValue={department_name}
                                value={department_id}
                                placeholder="Select Department"
                                onChange={(values) => changeValues('department_id', values)}
                                reloadDropdownData={() =>
                                  Base.dropdownData('departments', {}, [setDepartments], 1)
                                }
                              />
                              {errors.department_id && (
                                <ErrorMessage messages={errors.department_id} />
                              )}
                            </CInputGroup>
                          </CCol>
                          <CCol xl={2} lg={4} md={6}>
                            <CInputGroup>
                              <label>Designation</label>
                              <WidgetDesignationSelector
                                designations={designations}
                                displayValue={designation_name}
                                value={designation_id}
                                placeholder="Select Designation"
                                onChange={(values) => changeValues('designation_id', values)}
                                reloadDropdownData={() =>
                                  Base.dropdownData('designations', {}, [setDesignations], 1)
                                }
                              />
                              {errors.designation_id && (
                                <ErrorMessage messages={errors.designation_id} />
                              )}
                            </CInputGroup>
                          </CCol>
                          <CCol xl={2} lg={4} md={6}>
                            <CInputGroup>
                              <label>Job Type</label>
                              <WidgetSelector
                                options={JobTypeOptions}
                                placeHolder={'Please Select'}
                                selectedValue={JobType}
                                onChange={(values) => setJobType(values.value)}
                              />
                              {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                            </CInputGroup>
                          </CCol>
                          <CCol xl={2} lg={4} md={6}>
                            <CInputGroup>
                              <label>Resignation Status</label>
                              <WidgetSelector
                                options={RESIGNATION_STATUS_DROPDOWN_OPTIONS}
                                placeHolder={'Please Select'}
                                selectedValue={ResignationStatus}
                                onChange={(values) => changeValues('resignation_status', values)}
                              />
                              {errors.resignation_status && (
                                <ErrorMessage messages={errors.resignation_status} />
                              )}
                            </CInputGroup>
                          </CCol>
                          <CCol xl={2} lg={4} md={6}>
                            <CInputGroup>
                              <label>Parent Branch</label>
                              <WidgetBranchSelector
                                branches={branches}
                                displayValue={branch_name}
                                value={branchId}
                                placeholder="Select Branch"
                                onChange={(values) => changeValues('branch_id', values)}
                                reloadDropdownData={() =>
                                  Base.dropdownData('branches', {}, [setBranches], 1)
                                }
                              />
                              {errors.department_id && (
                                <ErrorMessage messages={errors.department_id} />
                              )}
                            </CInputGroup>
                          </CCol>
                          <CCol xl={2} lg={4} md={6}>
                            <div
                              style={{
                                display: 'flex',
                                gap: '8px',
                                flexWrap: 'wrap',
                                alignItems: 'flex-end',
                                height: '100%',
                                minHeight: '72px',
                              }}
                            >
                              <CButton color="primary" onClick={() => getReportData()}>
                                Search
                              </CButton>
                              <CButton
                                color="success"
                                className="text-white"
                                onClick={exportToExcel}
                              >
                                Export
                              </CButton>
                              <CButton
                                color="danger"
                                className="text-white"
                                onClick={generatePDF}
                              >
                                PDF
                              </CButton>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </div>
                  </div>
                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        <table className="table table-bordered data-table">
          {isLoading ? (
            Loading
          ) : (
            <>
              {reportData.length > 0 ? (
                <DataReportTable
                  reportData={reportData}
                  setReportData={(data) => setReportData(data)}
                  isLoading={isLoading}
                  formatDate={formatDate}
                />
              ) : (
                <center style={{ fontSize: '19px', fontWeight: 'bold' }}>No record to show...</center>
              )}
            </>
          )}
        </table>

      </div>
    </>
  )
}
